import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getErrorHttpMessage } from "utils";
import { StoreType } from "types/genericTypes";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  cambiarEmpresaRequisicionHttp,
  cambiarProyectoRequisicionHttp,
  cancelarRequisicionHttp,
  createRequisicionHttp,
  getBitacoraRequisicionHttp,
  getJefeInmediatoHttp,
  getRequisicionesHttp,
  getRequisicionPorIdHttp,
  mandarAutorizarHttp,
  marcarAtendidaHttp,
  marcarProductoAtendidoHttp,
  procesoAutorizacionHttp,
  reportarProblemaHttp,
  surtirDisponibleHttp,
  updateRequisicionHttp,
} from "actions/requisiciones";
import { getUsuariosHttp } from "actions/users";
import {
  asignarInventarioExistenteOnRequiHttp,
  createInventarioOnRequiHttp,
  getInventarioHttp,
} from "actions/inventario";
import { getCategoriasHttp } from "actions/categorias";
import { getTipoProductosHttp } from "actions/tipoProducto";
import { getProveedoresHttp, getProveedoresInventarioHttp } from "actions/proveedores";
import { createCotizacionHttp } from "actions/cotizacion";
import { getEmpresasHttp } from "actions/empresa";
import { getUnidadesMedidaHttp } from "actions/unidadMedida";
import { getUbicacionesHttp } from "actions/ubicacion";
import { normalizarFilasInventario } from "modules/inventario/utils/inventarioNormalizar.utils";
import { FilaInventario } from "modules/inventario/types/inventario.types";
import { validarImagenReferencia } from "utils/validarImagen";
import env from "react-dotenv";
import type { DetalleProducto } from "modules/productoSeleccionado/types/productoSeleccionado.types";
import {
  crearIdLinea,
  faltaComentario,
  formatearMoneda,
} from "modules/productoSeleccionado/utils/productoSeleccionado.utils";
import { getProyectosHttp } from "actions/proyecto";
import { useGestionCotizacion } from "modules/gestionCotizacion";

interface Proveedor {
  id_proveedor: number;
  razon_social: string;
  nombre_comercial: string;
  contacto: string;
  correo: string;
  telefono: string;
}

interface ProveedorPorProducto {
  nombre_producto?: string;
  tipo_movimiento?: number;
  proveedores: Proveedor[];
}

export const useRequisicion = () => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const idRequisicionUrl = searchParams.get("idr");

  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const idUsuario = useSelector((state: StoreType) => state?.app?.user?.data?.id_usuario || 0);
  const idDireccionUsuario = useSelector(
    (state: StoreType) => state?.app?.user?.data?.id_direccion || 0
  );
  const privilegiosToRol: Record<string, string> = {
    "froebel.ivan": "admin",
    "torres.tannya": "daf",
    "salazar.mario": "dg",
    "hernandez.lucero": "compras",
    "delarosa.brenda": "compras",
  };

  const [procesando, setProcesando] = useState<boolean>(true);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [mensajeAlert, setMensajeAlert] = useState("");
  const handleisAlertOpen = () => setIsAlertOpen(true);
  const handleisAlertClose = () => setIsAlertOpen(false);

  /* CREAR CATEGORÍA */
  const [procesandoRequisicion, setProcesandoRequisicion] = useState<boolean>(false);
  const [isAlertOpenCrearRequisicion, setIsAlertOpenCrearRequisicion] = useState(false);
  const handleisAlertCrearRequisicionOpen = () => {
    limpiarFormularioRequisicion();
    setIsAlertOpenCrearRequisicion(true);
  };
  const handleisAlertCrearRequisicionClose = () => {
    setIsAlertOpenCrearRequisicion(false);
    limpiarFormularioRequisicion();
  };

  const [productos, setProductos] = useState<any[]>([]);
  const [usuarios, setUsuarios] = useState<any[]>([]);
  const [requisiciones, setRequisiciones] = useState<any[]>([]);
  //proveedores
  const [proveedores, setProveedores] = useState<any[]>([]);

  // Estados para la paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //para buscador
  const [buscador, setBuscador] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(null);

  const [visualizacion, setVisualizacion] = useState<string | null>("cuadricula");

  const [detalles, setDetalles] = useState<DetalleProducto[]>([]);

  //Modal de añadir producto
  const [productoSearch, setProductoSearch] = useState("");

  //Paginación del modal de productos
  const [pageProductos, setPageProductos] = useState(0);
  const [rowsPerPageProductos, setRowsPerPageProductos] = useState(6);

  //Modal de ver detalles de la requisicion
  const [verDetalleRequisicion, setVerDetalleRequisicion] = useState<any>(null);
  const [isAlertOpenDetalleRequisicion, setIsAlertOpenDetalleRequisicion] = useState(false);
  const handleisAlertOpenDetalleRequisicion = () => setIsAlertOpenDetalleRequisicion(true);
  const handleisAlertCloseDetalleRequisicion = () => {
    ultimaPeticionDetalle.current++;
    setCargandoDetalle(false);
    setIsAlertOpenDetalleRequisicion(false);
  };

  //Cotizacion por compras
  const [procesandoCotizacion, setProcesandoCotizacion] = useState<boolean>(false);

  const [accionRequisicion, setAccionRequisicion] = useState<string>("");

  const [jefeInmediato, setJefeInmediato] = useState<any>(null);

  const [tipoProductos, setTipoProductos] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [empresas, setEmpresas] = useState<any[]>([]);
  const [proyectos, setProyectos] = useState<any[]>([]);
  const [inventarios, setInventarios] = useState<any[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<any[]>([]);
  const [ubicaciones, setUbicaciones] = useState<any[]>([]);
  const [almacenes, setAlmacenes] = useState<any[]>([]);

  //Modal de ver detalles de la cotización
  const [datosCotizacion, setDatosCotizacion] = useState<any>(null);
  const [cotizacionLista, setCotizacionLista] = useState(false);
  const [verCotizacion, setVerCotizacion] = useState<any>(null);
  const [isAlertOpenCotizacion, setIsAlertOpenCotizacion] = useState(false);
  const handleisAlertOpenCotizacion = () => setIsAlertOpenCotizacion(true);
  const handleisAlertCloseCotizacion = () => {
    setIsAlertOpenCotizacion(false);
    setDatosCotizacion(null);
    setCotizacionLista(false);
    gestion.reiniciar();
  };
  // Estado para los proveedores por producto
  const [proveedoresPorProducto, setProveedoresPorProducto] = useState<
    Record<string, ProveedorPorProducto>
  >({});
  const [procesandoProveedores, setProcesandoProveedores] = useState<boolean>(false);

  //obtener bitacora de requisicion
  const [bitacora, setBitacora] = useState<any[]>([]);
  const [isAlertOpenBitacora, setIsAlertOpenBitacora] = useState(false);
  const handleisAlertOpenBitacora = () => setIsAlertOpenBitacora(true);
  const handleisAlertCloseBitacora = () => setIsAlertOpenBitacora(false);

  const [procesandoEnModal, setProcesandoEnModal] = useState<boolean>(false);

  /* CREAR PRODUCTO NUEVO */
  const [procesandoInventario, setProcesandoInventario] = useState<boolean>(false);
  const [isAlertOpenCrearInventario, setIsAlertOpenCrearInventario] = useState(false);
  const handleisAlertCrearInventarioOpen = () => setIsAlertOpenCrearInventario(true);
  const handleisAlertCrearInventarioClose = () => setIsAlertOpenCrearInventario(false);

  const [procesandoModal, setProcesandoModal] = useState<boolean>(false);

  const [idDetalleRequisicion, setIdDetalleRequisicion] = useState<number>(0);

  /* SELECCIONAR PRODUCTO EXISTENTE */
  const [isAlertOpenListaSeleccionable, setIsAlertOpenListaSeleccionable] = useState(false);
  const handleisAlertOpenListaSeleccionable = () => setIsAlertOpenListaSeleccionable(true);
  const handleisAlertCloseListaSeleccionable = () => setIsAlertOpenListaSeleccionable(false);
  const [productoDetalle, setProductoDetalle] = useState<FilaInventario | null>(null);

  //subir imagen de referencia
  const [imagenReferencia, setImagenReferencia] = useState<File | null>(null);
  const [errorImagen, setErrorImagen] = useState<string | null>(null);

  /* EDITAR REQUISICIÓN */
  const [modoEdicion, setModoEdicion] = useState<boolean>(false);
  const [idRequisicionEditar, setIdRequisicionEditar] = useState<number | null>(null);
  const [imagenReferenciaActual, setImagenReferenciaActual] = useState<string | null>(null);

  /* VISTA PREVIA DE IMAGEN DE REFERENCIA */
  const [isModalImagenOpen, setIsModalImagenOpen] = useState(false);
  const handleOpenModalImagen = () => setIsModalImagenOpen(true);
  const handleCloseModalImagen = () => setIsModalImagenOpen(false);

  //requisición individual
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const ultimaPeticionDetalle = useRef(0);

  //Modal de ver productos de la cotizacion por proveedor
  const gestion = useGestionCotizacion({
    idUsuario,
    notificar: (mensaje) => {
      setMensajeAlert(mensaje);
      handleisAlertOpen();
    },
    onCargando: setProcesando,
    proveedores,
  });

  //Boton de cotizar en el modal
  const handleCambioCotizacion = useCallback((datos: any, listo: boolean) => {
    setDatosCotizacion(datos);
    setCotizacionLista(listo);
  }, []);
  const enviarCotizacion = () => {
    if (!datosCotizacion || !cotizacionLista) return;
    crearCotizacion(datosCotizacion);
  };

  //boton atendido
  const tipoUsuarioArjion = privilegiosToRol[userName as string] ?? "";
  const proveedorCotizado = verDetalleRequisicion?.proveedores_seleccionados?.[0] ?? null;
  const ordenesCompra: any[] = Array.isArray(verDetalleRequisicion?.ordenes_compra)
    ? verDetalleRequisicion.ordenes_compra
    : verDetalleRequisicion?.orden_compra?.id
      ? [verDetalleRequisicion.orden_compra]
      : [];
  const todasOrdenesSurtidas =
    ordenesCompra.length > 0 &&
    ordenesCompra.every((oc) => Number(oc.estatus_id) === 5);
  const puedeMarcarAtendida =
    !cargandoDetalle &&
    tipoUsuarioArjion === "compras" &&
    !!proveedorCotizado &&
    todasOrdenesSurtidas;

  const handleMarcarAtendida = () => {
    if (!verDetalleRequisicion) return;
    const detalles = ordenesCompra
      .flatMap((oc: any) => oc.detalles_orden_compra ?? [])
      .map((d: any) => ({
        id_inventario: d.id_inventario,
        cantidad: Number(d.cantidad),
        precio: Number(d.precio),
      }));

    marcarAtendida({
      id_requisicion: verDetalleRequisicion.id,
      id_usuario: idUsuario,
      detalles,
    });
  };

  const handleChangeImagen = async (newFile: File | null) => {
    setErrorImagen(null);

    if (!newFile) {
      setImagenReferencia(null);
      return;
    }

    const { error, tipo } = await validarImagenReferencia(newFile);

    if (error || !tipo) {
      setErrorImagen(error);
      setImagenReferencia(null);
      return;
    }

    const base = newFile.name.replace(/\.[^.]+$/, "");
    const extActual = newFile.name.split(".").pop()?.toLowerCase();
    const extCorrecta = tipo === "jpg" ? "jpg" : tipo;

    const archivo =
      extActual === extCorrecta || (tipo === "jpg" && extActual === "jpeg")
        ? newFile
        : new File([newFile], `${base}.${extCorrecta}`, { type: `image/${extCorrecta}` });

    setImagenReferencia(archivo);
  };

  const handleAccionRequisicion = (
    event: React.MouseEvent<HTMLElement>,
    nuevaAccionRequisicion: string
  ) => {
    setAccionRequisicion(nuevaAccionRequisicion);
  };

  const handleChangePageProductos = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageProductos(newPage);
  };

  const handleChangeRowsPerPageProductos = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPageProductos(parseInt(event.target.value, 10));
    setPageProductos(0);
  };

  const handleProductoSearchChange = (value: string) => {
    setProductoSearch(value);
    setPageProductos(0);
  };

  const handleAgregarLinea = useCallback((producto: any, cantidad: number, observaciones = "") => {
    const precio = Number(producto.precio) || 0;
    setDetalles((prev) => [
      ...prev,
      {
        id_linea: crearIdLinea(),
        id_inventario: producto.id ?? producto.id_inventario,
        nombre: producto.nombre,
        clave: producto.clave,
        tipo_producto: producto.tipo_producto?.nombre ?? producto.tipo_producto ?? "",
        precio_unitario: precio,
        cantidad,
        unidad_medida: producto.unidad_medida?.nombre ?? producto.unidad_medida ?? "",
        precio_total: precio * cantidad,
        observaciones,
      },
    ]);
  }, []);

  const handleCambiarObservacionesLinea = useCallback((idLinea: string, observaciones: string) => {
    setDetalles((prev) => prev.map((d) => (d.id_linea === idLinea ? { ...d, observaciones } : d)));
  }, []);

  const handleCambiarCantidadLinea = useCallback((idLinea: string, cantidad: number) => {
    setDetalles((prev) =>
      prev.map((d) =>
        d.id_linea === idLinea ? { ...d, cantidad, precio_total: d.precio_unitario * cantidad } : d
      )
    );
  }, []);

  const handleRemoveDetalle = useCallback((idLinea: string) => {
    setDetalles((prev) => prev.filter((d) => d.id_linea !== idLinea));
  }, []);

  const totalPedido = useMemo(
    () => detalles.reduce((sum, d) => sum + d.precio_total, 0),
    [detalles]
  );

  const handleVisualizacion = (
    event: React.MouseEvent<HTMLElement>,
    nuevaVisualizacion: string | null
  ) => {
    if (nuevaVisualizacion === "tabla") {
      handleBuscadorChange({
        target: { value: "" },
      } as React.ChangeEvent<HTMLInputElement>);
    }
    setVisualizacion(nuevaVisualizacion);
  };

  const handleBuscadorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setBuscador(value);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    const timeout = setTimeout(() => {
      getRequisiciones({ search: value });
    }, 500);
    setDebounceTimeout(timeout);
  };

  const formikInventario = useFormik({
    initialValues: {
      clave: "",
      nombre: "",
      precio: "",
      id_unidad_medida: "",
      id_categoria: "",
      id_ubicacion: "",
      id_tipo_producto: "",
      cantidad: "",
      maximos: "",
      minimos: "",
      punto_reorden: "",
    },
    validationSchema: Yup.object({
      clave: Yup.string(),
      nombre: Yup.string().required(intl.formatMessage({ id: "input_validation_requerido" })),
      precio: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_unidad_medida: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      id_categoria: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_ubicacion: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_tipo_producto: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      cantidad: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      maximos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      minimos: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      punto_reorden: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
    }),
    validateOnMount: true,
    onSubmit: async (values) => { },
  });

  const isFieldValidInventario = (fieldName: keyof typeof formikInventario.values) => {
    return (
      formikInventario.touched[fieldName] &&
      !formikInventario.errors[fieldName] &&
      formikInventario.values[fieldName] &&
      formikInventario.values[fieldName] !== ""
    );
  };

  const getFieldColorInventario = (fieldName: keyof typeof formikInventario.values) => {
    return isFieldValidInventario(fieldName) ? "#00AB16" : undefined;
  };

  const formik = useFormik({
    initialValues: {
      id_usuario: "",
      id_tipo_producto: "",
      id_empresa: "",
      extras: "",
    },
    validationSchema: Yup.object({
      id_usuario: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      id_tipo_producto: Yup.number().required(
        intl.formatMessage({ id: "input_validation_requerido" })
      ),
      id_empresa: Yup.number().required(intl.formatMessage({ id: "input_validation_requerido" })),
      extras: Yup.string(),
    }),
    onSubmit: async (values) => { },
  });

  const isFieldValid = (fieldName: keyof typeof formik.values) => {
    return (
      formik.touched[fieldName] &&
      !formik.errors[fieldName] &&
      formik.values[fieldName] &&
      formik.values[fieldName] !== ""
    );
  };

  const getFieldColor = (fieldName: keyof typeof formik.values) => {
    return isFieldValid(fieldName) ? "#00AB16" : undefined;
  };

  const normalizarTexto = (texto: string): string =>
    texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

  const productosFiltradosPorTipo = useMemo(() => {
    const tipoSeleccionado = formik.values.id_tipo_producto;
    if (!tipoSeleccionado) return productos;
    return productos.filter((p: any) => String(p.id_tipo_producto) === String(tipoSeleccionado));
  }, [productos, formik.values.id_tipo_producto]);

  const productosFiltrados =
    productosFiltradosPorTipo?.filter((p: any) =>
      normalizarTexto(p.nombre).includes(normalizarTexto(productoSearch))
    ) ?? [];

  const limpiarFormularioRequisicion = () => {
    formik.resetForm();
    setDetalles([]);
    setImagenReferencia(null);
    setImagenReferenciaActual(null);
    setErrorImagen(null);
    setModoEdicion(false);
    setIdRequisicionEditar(null);
  };

  const handleEditarRequisicion = (requisicion: any) => {
    if (!requisicion) return;

    const detallesRequi = requisicion.detalles ?? [];

    formik.setValues({
      id_usuario: requisicion.id_usuario_solicitante ?? "",
      id_tipo_producto: detallesRequi[0]?.inventario?.id_tipo_producto ?? "",
      id_empresa: requisicion.empresa?.id ?? "",
      extras: requisicion.extras ?? "",
    });

    setDetalles(
      detallesRequi.map((d: any) => ({
        id_linea: `bd-${d.id}`,
        id_detalle: d.id,
        id_inventario: d.id_inventario,
        nombre: d.inventario?.nombre ?? "",
        clave: d.inventario?.clave ?? "",
        tipo_producto: d.inventario?.tipo_producto?.nombre ?? "",
        precio_unitario: Number(d.precio_unitario) || 0,
        cantidad: Number(d.cantidad) || 0,
        unidad_medida: d.inventario?.unidad_medida?.nombre ?? "",
        precio_total: Number(d.precio_total) || 0,
        observaciones: d.comentarios ?? "",
      }))
    );

    setImagenReferencia(null);
    setImagenReferenciaActual(requisicion.imagen_referencia || null);

    setIdRequisicionEditar(requisicion.id);
    setModoEdicion(true);

    handleisAlertCloseDetalleRequisicion();
    setIsAlertOpenCrearRequisicion(true);
  };

  const serializarDetalles = (lista: DetalleProducto[]) =>
    JSON.stringify(lista.map(({ id_linea, ...resto }) => resto));

  const urlImagenReferencia = imagenReferenciaActual
    ? `${env.API_URL_ASSETS}referencias_requisicion/${imagenReferenciaActual}`
    : undefined;

  const getRequisicionPorId = useCallback(async (data: any, silencioso = false) => {
    const peticion = ++ultimaPeticionDetalle.current;
    try {
      if (!silencioso) setCargandoDetalle(true);
      const response = await getRequisicionPorIdHttp(data);
      if (peticion === ultimaPeticionDetalle.current) {
        setVerDetalleRequisicion(response);
      }
    } catch (error) {
      if (peticion === ultimaPeticionDetalle.current) {
        const message = getErrorHttpMessage(error);
        setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
        handleisAlertOpen();
      }
    } finally {
      if (peticion === ultimaPeticionDetalle.current) setCargandoDetalle(false);
    }
  }, []);

  const getProveedoresPorProductos = useCallback(async (ids_inventario: number[]) => {
    try {
      setProcesandoProveedores(true);
      const data: any = await getProveedoresInventarioHttp(ids_inventario);
      setProveedoresPorProducto(data);
      setProcesandoProveedores(false);
    } catch (error) {
      setProcesandoProveedores(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || "Error al obtener proveedores");
      handleisAlertOpen();
    }
  }, []);

  const getCategorias = useCallback(async (idTipoProducto?: number) => {
    try {
      setProcesando(true);
      const params = idTipoProducto ? { id_tipo_producto: idTipoProducto } : {};
      const categorias = await getCategoriasHttp(params);
      setCategorias(categorias);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUbicaciones = useCallback(async () => {
    try {
      setProcesando(true);
      const ubicaciones = await getUbicacionesHttp();
      setUbicaciones(ubicaciones);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getProveedores = useCallback(async () => {
    try {
      setProcesando(true);
      const proveedores = await getProveedoresHttp();
      setProveedores(proveedores);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getTipoProducto = useCallback(async () => {
    try {
      setProcesando(true);
      const tipoProductos = await getTipoProductosHttp();
      setTipoProductos(tipoProductos);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getEmpresas = useCallback(async () => {
    try {
      setProcesando(true);
      const empresas = await getEmpresasHttp();
      setEmpresas(empresas);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getProyectos = useCallback(async () => {
    try {
      setProcesando(true);
      const proyectos = await getProyectosHttp();
      setProyectos(proyectos);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUsuarios = useCallback(async (datos?: any) => {
    try {
      setProcesando(true);
      const usuarios = await getUsuariosHttp(datos);
      setUsuarios(usuarios);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getCatalogoInventario = useCallback(async () => {
    try {
      setProcesando(true);
      const productos = await getInventarioHttp();
      setProductos(productos);
      setInventarios(productos);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getUnidadesMedida = useCallback(async () => {
    try {
      setProcesando(true);
      const unidadesMedida = await getUnidadesMedidaHttp();
      setUnidadesMedida(unidadesMedida);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const getRequisiciones = useCallback(
    async (params?: { search?: string; fecha1?: string; fecha2?: string }) => {
      try {
        setProcesando(true);
        const requisiciones = await getRequisicionesHttp(params?.search, idUsuario);
        setRequisiciones(requisiciones);
        setProcesando(false);
      } catch (error) {
        setProcesando(false);
        const message = getErrorHttpMessage(error);
        setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
        handleisAlertOpen();
      }
    },
    []
  );

  const getJefeInmediato = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const jefeInmediato = await getJefeInmediatoHttp(datos);
      setJefeInmediato(jefeInmediato);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  const crearCotizacion = async (datos: any) => {
    try {
      setProcesandoCotizacion(true);
      await createCotizacionHttp(datos);

      // Recarga las requisiciones para traer la cotización recién creada
      const lista = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(lista);

      const detalle: any = await getRequisicionPorIdHttp({
        id_requisicion: datos.id_requisicion,
      });

      setVerCotizacion(detalle);
      setVerDetalleRequisicion((prev: any) =>
        prev && String(prev.id) === String(detalle.id) ? detalle : prev
      );

      // Actualiza el listado en segundo plano
      getRequisicionesHttp(buscador, idUsuario).then(setRequisiciones).catch(() => { });

      setDatosCotizacion(null);
      setCotizacionLista(false);

      setMensajeAlert(intl.formatMessage({ id: "cotizacion_creada_correctamente" }));
      handleisAlertOpen();
    } catch (error) {
      setProcesandoCotizacion(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "cotizacion_creada_error" }));
      handleisAlertOpen();
    } finally {
      setProcesandoCotizacion(false);
    }
  };

  const createRequisicion = async (datos: any) => {
    try {
      setProcesandoModal(true);

      const formData = new FormData();
      formData.append("id_usuario", datos.id_usuario);
      formData.append("id_empresa", datos.id_empresa);
      formData.append("id_creador", datos.id_creador);
      formData.append("extras", datos.extras ?? "");
      if (datos.imagen_referencia) {
        formData.append("imagen_referencia", datos.imagen_referencia);
      }
      formData.append("detalles", serializarDetalles(datos.detalles));

      await createRequisicionHttp(formData);
      await getRequisiciones();

      setMensajeAlert(intl.formatMessage({ id: "general_añadido_correctamente" }));
      formik.resetForm();
      setDetalles([]);
      setImagenReferencia(null);

      handleisAlertCrearRequisicionClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_añadir_general" }));
      handleisAlertOpen();
    }
  };

  const reabrirRequisicion = async (datos: any) => {
    try {
      setProcesandoModal(true);

      const formData = new FormData();
      formData.append("id_requisicion", String(datos.id_requisicion));
      formData.append("id_usuario", datos.id_usuario);
      formData.append("id_empresa", datos.id_empresa);
      formData.append("id_editor", datos.id_editor);
      formData.append("extras", datos.extras ?? "");
      if (datos.imagen_referencia) {
        formData.append("imagen_referencia", datos.imagen_referencia);
      }
      formData.append("detalles", serializarDetalles(datos.detalles));

      await updateRequisicionHttp(formData);
      await getRequisiciones();

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertCrearRequisicionClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_actualizar_general" }));
      handleisAlertOpen();
    }
  };

  const marcarProductoAtendido = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await marcarProductoAtendidoHttp(datos);

      const productoEntregado = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(productoEntregado);

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        const actualizada = productoEntregado.find((r: any) => String(r.id) === String(prev.id));
        return actualizada ?? prev;
      });

      setMensajeAlert(intl.formatMessage({ id: "general_entregado_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_entregado_error" }));
      handleisAlertOpen();
    }
  };

  const cambiarProyectoRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await cambiarProyectoRequisicionHttp(datos);

      const proyectoCambiado = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(proyectoCambiado);

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        const actualizada = proyectoCambiado.find((r: any) => String(r.id) === String(prev.id));
        return actualizada ?? prev;
      });

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_actualizado_error" }));
      handleisAlertOpen();
    }
  };

  const reportarProblema = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await reportarProblemaHttp(datos);

      setMensajeAlert(intl.formatMessage({ id: "general_reportado_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_reportado_error" }));
      handleisAlertOpen();
    }
  };

  const cambiarEmpresaRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await cambiarEmpresaRequisicionHttp(datos);

      const empresaCambiada = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(empresaCambiada);

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        const actualizada = empresaCambiada.find((r: any) => String(r.id) === String(prev.id));
        return actualizada ?? prev;
      });

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_actualizado_error" }));
      handleisAlertOpen();
    }
  };

  const surtirDisponible = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await surtirDisponibleHttp(datos);

      const requisicionesActualizadas = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(requisicionesActualizadas);

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        const actualizada = requisicionesActualizadas.find(
          (r: any) => String(r.id) === String(prev.id)
        );
        return actualizada ?? prev;
      });

      setMensajeAlert(intl.formatMessage({ id: "general_surtido_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_surtido_error" }));
      handleisAlertOpen();
    }
  };

  const createInventarioOnRequi = async (datos: any) => {
    try {
      setProcesandoModal(true);
      const response: any = await createInventarioOnRequiHttp(datos);

      const inventario = response?.inventario ?? response;
      aplicarInventarioEnDetalle(datos.id_requisicion_detalle, Number(inventario?.id), inventario);

      setMensajeAlert(intl.formatMessage({ id: "general_añadido_correctamente" }));
      formikInventario.resetForm();
      setIdDetalleRequisicion(0);
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_añadir_general" }));
      handleisAlertOpen();
    }
  };
  const actualizarProductoEnRequisicion = async (producto: FilaInventario): Promise<boolean> => {
    const idDetalle = idDetalleRequisicion;
    try {
      setProcesandoModal(true);
      const idInventario = Number(producto.registro?.id ?? producto.id);

      const response: any = await asignarInventarioExistenteOnRequiHttp({
        id_inventario: idInventario,
        id_requisicion_detalle: idDetalleRequisicion,
      });
      const inventario = response?.inventario ?? producto.registro ?? producto;

      aplicarInventarioEnDetalle(idDetalle, idInventario, inventario);

      setMensajeAlert(intl.formatMessage({ id: "general_actualizado_correctamente" }));
      setIdDetalleRequisicion(0);
      handleisAlertCloseListaSeleccionable();
      handleisAlertCrearInventarioClose();
      handleisAlertOpen();
      setProcesandoModal(false);
      return true;
    } catch (error) {
      setProcesandoModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "error_actualizar_general" }));
      handleisAlertOpen();
      return false;
    }
  };

  const cancelarRequisicion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      const response: any = await cancelarRequisicionHttp(datos);

      const actualizada = response?.data ?? response;

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        if (String(actualizada?.id) !== String(prev.id)) return prev;
        return { ...prev, estatus_requisicion: 9 };
      });

      setRequisiciones((prev: any[]) =>
        prev.map((r) =>
          String(r.id) === String(datos.id_requisicion) ? { ...r, estatus_requisicion: 9 } : r
        )
      );

      setMensajeAlert(intl.formatMessage({ id: "general_cancelar_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_cancelar_error" }));
      handleisAlertOpen();
    }
  };

  const aplicarInventarioEnDetalle = (
    idDetalle: number,
    idInventario: number,
    inventario: any
  ) => {
    const actualizarDetalles = (detalles: any[] = []) =>
      detalles.map((d: any) =>
        String(d.id) === String(idDetalle)
          ? { ...d, id_inventario: idInventario, inventario }
          : d
      );

    setVerDetalleRequisicion((prev: any) =>
      prev ? { ...prev, detalles: actualizarDetalles(prev.detalles) } : prev
    );

    setRequisiciones((prev: any[]) =>
      prev.map((r) =>
        r.detalles?.some((d: any) => String(d.id) === String(idDetalle))
          ? { ...r, detalles: actualizarDetalles(r.detalles) }
          : r
      )
    );
  };

  useEffect(() => {
    const idTipo = formik.values.id_tipo_producto;
    if (idTipo) {
      getCategorias(Number(idTipo));
    } else {
      setCategorias([]);
    }
  }, [formik.values.id_tipo_producto]);

  useEffect(() => {
    getUbicaciones();
    getUnidadesMedida();
    getEmpresas();
    getProyectos();
    getCatalogoInventario();
    getUsuarios({ id_direccion: idDireccionUsuario });
    getRequisiciones();
    getCategorias();
    getTipoProducto();
    getProveedores();
  }, []);

  // Handlers para la paginación
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const requisicionesPaginadas = useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return requisiciones?.slice(startIndex, endIndex) || [];
  }, [requisiciones, page, rowsPerPage]);

  const productosPaginadosModal = useMemo(() => {
    const start = pageProductos * rowsPerPageProductos;
    return productosFiltrados.slice(start, start + rowsPerPageProductos);
  }, [productosFiltrados, pageProductos, rowsPerPageProductos]);

  //AUTORIZACIONES
  const enviarAutorizar = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await mandarAutorizarHttp(datos);
      setMensajeAlert(intl.formatMessage({ id: "general_enviado_autorizar_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_enviado_autorizar_error" }));
      handleisAlertOpen();
    }
  };

  const procesoAutorizacion = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await procesoAutorizacionHttp(datos);

      const requisicionesActualizadas = await getRequisicionesHttp(buscador, idUsuario);
      setRequisiciones(requisicionesActualizadas);

      setVerDetalleRequisicion((prev: any) => {
        if (!prev) return prev;
        const actualizada = requisicionesActualizadas.find(
          (r: any) => String(r.id) === String(prev.id)
        );
        return actualizada ?? prev;
      });

      setMensajeAlert(intl.formatMessage({ id: "general_autorizado_correctamente" }));
      handleisAlertOpen();
      setAccionRequisicion("");
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_autorizado_error" }));
      handleisAlertOpen();
    }
  };

  const marcarAtendida = async (datos: any) => {
    try {
      setProcesandoEnModal(true);
      await marcarAtendidaHttp(datos);
      setRequisiciones((prev: any[]) =>
        prev.map((r) => (r.id === datos.id_requisicion ? { ...r, estatus_requisicion: 6 } : r))
      );

      setVerDetalleRequisicion((prev: any) =>
        prev?.id === datos.id_requisicion ? { ...prev, estatus_requisicion: 6 } : prev
      );
      setMensajeAlert(intl.formatMessage({ id: "general_marcar_atendido_correctamente" }));
      handleisAlertOpen();
      setProcesandoEnModal(false);
    } catch (error) {
      setProcesandoEnModal(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "general_marcar_atendido_error" }));
      handleisAlertOpen();
    }
  };

  //bitacora de requisicion
  const getBitacoraRequisicionPorId = useCallback(async (datos: any) => {
    try {
      setProcesando(true);
      const response = await getBitacoraRequisicionHttp(datos);
      setBitacora(response);
      setProcesando(false);
    } catch (error) {
      setProcesando(false);
      const message = getErrorHttpMessage(error);
      setMensajeAlert(message || intl.formatMessage({ id: "get_elementos_error" }));
      handleisAlertOpen();
    }
  }, []);

  //gestion de cotizaciones
  const idCotizacionActual = verCotizacion?.cotizacion?.id;
  useEffect(() => {
    if (isAlertOpenCotizacion && idCotizacionActual) {
      gestion.cargarCotizacion(idCotizacionActual);
    }
  }, [isAlertOpenCotizacion, idCotizacionActual]);

  useEffect(() => {
    if (idRequisicionUrl && requisiciones && requisiciones.length > 0) {
      const requisicionEncontrada = requisiciones.find(
        (c: any) => String(c.id) === String(idRequisicionUrl)
      );

      if (requisicionEncontrada) {
        const datos = {
          id_usuario_creador: requisicionEncontrada?.id_creador,
          id_requisicion: requisicionEncontrada?.id,
        };
        getRequisicionPorId(datos);
        getJefeInmediato(datos);
        handleisAlertOpenDetalleRequisicion();
      }
    }
  }, [idRequisicionUrl, requisiciones]);

  const filasInventario = useMemo(
    () =>
      normalizarFilasInventario(inventarios, {
        textoActivo: intl.formatMessage({ id: "general_activo" }),
        textoInactivo: intl.formatMessage({ id: "general_inactivo" }),
      }),
    [inventarios, intl]
  );
  // id_inventario que ya están en la requisición abierta
  const inventariosEnRequisicion = useMemo(
    () =>
      new Set<string>(
        (verDetalleRequisicion?.detalles ?? [])
          .map((d: any) => d.id_inventario)
          .filter((id: unknown) => id !== null && id !== undefined && id !== "")
          .map(String)
      ),
    [verDetalleRequisicion?.detalles]
  );
  // Productos que se pueden elegir en "Seleccionar existente"
  const filasInventarioSeleccionables = useMemo(
    () =>
      filasInventario.filter(
        (f) => !inventariosEnRequisicion.has(String(f.registro?.id ?? f.id))
      ),
    [filasInventario, inventariosEnRequisicion]
  );

  const urlVerImagenReferencia = verDetalleRequisicion?.imagen_referencia
    ? `${env.API_URL_ASSETS}referencias_requisicion/${verDetalleRequisicion.imagen_referencia}`
    : undefined;

  const lineasSinComentario = detalles.filter(faltaComentario).length;
  const textoProductos = detalles.length > 1 ? " productos" : " producto";
  const countProductosSeleccionados = detalles.length + textoProductos;
  const totalPedidoTexto = "Total del pedido: " + formatearMoneda(totalPedido);

  const botonRequisicionDeshabilitado =
    procesandoRequisicion ||
    !formik.isValid ||
    (!modoEdicion && !formik.dirty) ||
    detalles.length === 0 ||
    lineasSinComentario > 0 ||
    Boolean(errorImagen);

  return {
    intl,
    formik,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    requisiciones,
    //crear requisicion
    isAlertOpenCrearRequisicion,
    handleisAlertCrearRequisicionOpen,
    handleisAlertCrearRequisicionClose,
    getFieldColor,
    createRequisicion,
    requisicionesPaginadas,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    buscador,
    handleBuscadorChange,
    visualizacion,
    handleVisualizacion,
    idUsuario,
    usuarios,
    tipoProductos,
    categorias,
    // productos
    detalles,
    handleRemoveDetalle,
    // modal producto
    productoSearch,
    productosFiltrados,
    //paginacion de productos de inventario
    pageProductos,
    rowsPerPageProductos,
    handleChangePageProductos,
    handleChangeRowsPerPageProductos,
    handleProductoSearchChange,
    productosPaginadosModal,
    //ver detalles de la requisicion
    isAlertOpenDetalleRequisicion,
    handleisAlertOpenDetalleRequisicion,
    handleisAlertCloseDetalleRequisicion,
    verDetalleRequisicion,
    setVerDetalleRequisicion,
    //cotizacion
    procesandoCotizacion,
    //autorizar
    enviarAutorizar,
    procesoAutorizacion,
    accionRequisicion,
    handleAccionRequisicion,
    getJefeInmediato,
    jefeInmediato,
    setAccionRequisicion,
    //detalles cotización
    verCotizacion,
    setVerCotizacion,
    isAlertOpenCotizacion,
    handleisAlertOpenCotizacion,
    handleisAlertCloseCotizacion,
    proveedoresPorProducto,
    procesandoProveedores,
    getProveedoresPorProductos,
    surtirDisponible,
    handleCambioCotizacion,
    cotizacionLista,
    enviarCotizacion,
    //mostrar bitacora de requisicion
    getBitacoraRequisicionPorId,
    bitacora,
    setBitacora,
    isAlertOpenBitacora,
    handleisAlertOpenBitacora,
    handleisAlertCloseBitacora,
    empresas,
    //imagen referencia
    handleChangeImagen,
    setImagenReferencia,
    imagenReferencia,
    //crear producto nuevo
    procesandoInventario,
    isAlertOpenCrearInventario,
    handleisAlertCrearInventarioOpen,
    handleisAlertCrearInventarioClose,
    formikInventario,
    getFieldColorInventario,
    unidadesMedida,
    ubicaciones,
    almacenes,
    createInventarioOnRequi,
    procesandoModal,
    setIdDetalleRequisicion,
    idDetalleRequisicion,
    //lista seleccionable de productos
    isAlertOpenListaSeleccionable,
    handleisAlertOpenListaSeleccionable,
    handleisAlertCloseListaSeleccionable,
    filasInventario,
    setProductoDetalle,
    productoDetalle,
    actualizarProductoEnRequisicion,
    errorImagen,
    cancelarRequisicion,
    procesandoEnModal,
    //editar requisiciones
    modoEdicion,
    idRequisicionEditar,
    imagenReferenciaActual,
    handleEditarRequisicion,
    reabrirRequisicion,
    urlImagenReferencia,
    isModalImagenOpen,
    handleOpenModalImagen,
    handleCloseModalImagen,
    urlVerImagenReferencia,
    handleAgregarLinea,
    handleCambiarCantidadLinea,
    handleCambiarObservacionesLinea,
    marcarProductoAtendido,
    lineasSinComentario,
    botonRequisicionDeshabilitado,
    countProductosSeleccionados,
    totalPedidoTexto,
    proyectos,
    cambiarProyectoRequisicion,
    cambiarEmpresaRequisicion,
    reportarProblema,
    proveedores,
    getRequisicionPorId,
    cargandoDetalle,
    userName,
    puedeMarcarAtendida,
    handleMarcarAtendida,
    //gestion de cotizaciones
    gestion,
    filasInventarioSeleccionables,
  };
};
